<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-spin-clockwise">
</ngx-spinner>

<nb-layout>
	<nb-layout-header fixed>
		<div class="toolbar" role="banner">
			<img alt="Logo" [src]="logo" class="logo" />
			<div class="spacer"></div>
		</div>
	</nb-layout-header>

	<nb-layout-column>
		<div class="content" role="main" *ngIf="!loading">
			<div class="container">
				<nb-card class="card">
					<nb-card-header class="card-header">
						<nb-icon icon="search-outline" class="header-icon"></nb-icon>
						{{ config.FormTitle || 'Consulta de seguimiento' }}
					</nb-card-header>

					<nb-card-body class="card-body">
						<p class="card-description">Introduce tu número de seguimiento para consultar el estado de tu expediente.</p>

						<div class="search-form">
							<input
								nbInput
								fullWidth
								type="text"
								placeholder="Número de seguimiento"
								[(ngModel)]="trackingId"
								(keyup.enter)="onSearch()"
								class="tracking-input"/>
							<button
								nbButton
								status="primary"
								size="large"
								(click)="onSearch()"
								class="search-button">
								<nb-icon icon="search-outline"></nb-icon>
								Consultar
							</button>
						</div>
					</nb-card-body>
				</nb-card>
			</div>
		</div>
	</nb-layout-column>
</nb-layout>
